import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const About = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="about-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-black/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Sobre Alphatica
          </h1>
          <p className="text-brand-black/60 text-lg">
            Fragancias de inspiración con identidad propia
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-brand-black/80 leading-relaxed mb-6">
              Alphatica es una marca dedicada al desarrollo y comercialización de fragancias de
              inspiración, también conocidas como perfumes equivalentes o prototipos olfativos.
              Nuestro objetivo es acercar al público aromas sofisticados inspirados en perfumes
              comerciales y de nicho, ofreciendo una alternativa accesible sin comprometer la calidad de
              la experiencia aromática.
            </p>

            <p className="text-brand-black/80 leading-relaxed mb-6">
              Cada fragancia de Alphatica es elaborada a partir de composiciones aromáticas
              cuidadosamente seleccionadas, diseñadas para evocar características olfativas de perfumes
              reconocidos, pero siempre bajo una identidad propia y una marca independiente.
            </p>

            <div className="brand-card hybrid-glow p-6 rounded-lg my-8">
              <h2 className="font-display text-xl mb-4 text-brand-cobalt">Nuestro Compromiso</h2>
              <ul className="space-y-3 text-brand-black/80">
                <li className="flex items-start gap-2">
                  <span className="text-brand-cobalt mt-1">•</span>
                  Las fragancias comercializadas por Alphatica son desarrolladas de manera independiente y
                  no pretenden replicar ni copiar productos originales protegidos por derechos de marca o
                  propiedad intelectual.
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-brand-cobalt mt-1">•</span>
                  Alphatica no utiliza nombres, logotipos, empaques ni elementos visuales pertenecientes a
                  marcas registradas de terceros.
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-brand-cobalt mt-1">•</span>
                  Las referencias aromáticas que puedan mencionarse en el sitio web tienen únicamente fines
                  descriptivos para ayudar a los clientes a identificar perfiles olfativos similares.
                </li>
              </ul>
            </div>

            <p className="text-brand-black/80 leading-relaxed mb-6">
              Alphatica es una marca independiente y no tiene relación, afiliación ni autorización por
              parte de las casas perfumistas o marcas que puedan servir como inspiración para
              determinadas fragancias.
            </p>

            <p className="text-brand-black leading-relaxed font-medium">
              Nuestro compromiso es ofrecer productos de calidad que permitan a más personas disfrutar
              de aromas sofisticados a precios accesibles.
            </p>
          </div>

          {/* CTA */}
          <div className="mt-12 text-center">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 brand-btn rounded"
            >
              Explorar Colección
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
